<template>
  <div>
    <div class="ElasticResource-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.region }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/ElasticResourceAli">{{
          $t("alarms.elasticResource.elasticResource")
        }}</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t("alarms.common.alertRule") }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <template>
      <Tabs size="small" :animated="false">
        <TabPane :label="$t('alarms.common.alertRule')">
          <div class="ElasticResource-top">
            <elastic-resource-ali-warning-search></elastic-resource-ali-warning-search>
          </div>
          <table-elastic-resource-ali-warning></table-elastic-resource-ali-warning>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import ElasticResourceAliWarningSearch from "../eip/ElasticResourceSearch";
import TableElasticResourceAliWarning from "../eip/TableElasticResourceAliWarning";

export default {
  name: "ElasticResourceAliWarning",
  components: {
    ElasticResourceAliWarningSearch,
    TableElasticResourceAliWarning,
  },
  data() {
    return {
      id: "",
      accountId: "",
      instanceId: "",
      accountTypeName: "",
      accountName: "",
      region: "",
      privateIp: "",
    };
  },
  methods: {
    // 点击返回详情页
    ipAddress: function () {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.instanceId = this.$route.query.instanceId;
      this.region = this.$route.query.region;
      this.privateIp = this.$route.query.privateIp;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.accountName = this.$route.query.accountName;
      this.name = this.$route.query.name;
      this.$router.push({
        path: "/monitor/ElasticResourceDetailAli/",
        query: {
          id: this.id,
          accountId: this.accountId,
          instanceId: this.instanceId,
          region: this.region,
          privateIp: this.privateIp,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name,
        },
      });
    },
  },
};
</script>

<style scoped>
.ElasticResource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
  font-weight: 600;
}
.ElasticResource-top {
  width: 100%;
  height: 32px;
  margin-bottom: 14px;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/eip/ElasticResourceAliWarning.vue